<template>
  <div>
    <ag-grid-vue
      style="height: 300px"
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 ag-grid-table"
      :columnDefs="getTable.column"
      :defaultColDef="defaultColDef"
      :rowData="getTable.data"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      @first-data-rendered="onFirstDataRendered"
      @rowDataChanged="onFirstDataRendered"
      @gridReady="onGridReady"
    >
    </ag-grid-vue>
    <!-- <ag-grid-vue
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 ag-grid-table"
      :columnDefs="getTable.column"
      :defaultColDef="defaultColDef"
      :rowData="getTable.data"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      @first-data-rendered="onFirstDataRendered"
    >
    </ag-grid-vue> -->
    <!-- <vs-pagination
      :total="totalPages"
      :max="maxPageNumbers"
      v-model="currentPage"
    /> -->
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import iconDetail from "./iconDetail";
import iconDelete from "./iconDelete";
import Dropdown from "./Dropdown";
import String from "./String";
import Date from "./Date";
import Float from "./Float";
import Number from "./Number";
import Array from "./Array";
import More from "./More";
import Percent from "./Percent";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
// import "@/assets/scss/vuexy/extraComponents/agGridStyleTableOnly.scss"
import themeConfig from "@/../themeConfig.js";
import data from "../data";
export default {
  components: {
    AgGridVue,
    iconDetail,
    iconDelete,
    Dropdown,
    String,
    Date,
    Float,
    Number,
    Array,
    More,
    Percent,
  },
  props: ["getData", "selectedTask", "selectedInvoice"],
  data() {
    return {
      tableData: data,
      bermuda: null,
      searchQuery: "",
      gridOptions: { domLayout: "normal" },
      maxPageNumbers: 7,
      gridApi: "sizeColumnsToFit",
      defaultColDef: null,
      // invoiceTable: this.getTable,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
  },
  computed: {
    ...mapGetters({
      tab: "general/tab",
      nowPage: "getNowPage",
      getTable: "general/subTable",
    }),
    // paginationPageSize() {
    //   if (this.gridApi) return this.gridApi.paginationGetPageSize();
    //   else return 50;
    // },
    // totalPages() {
    //   if (this.gridApi) return this.gridApi.paginationGetTotalPages();
    //   else return 0;
    // },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  watch: {
    getTable() {
      this.spliceTable();
    },
  },
  methods: {
    spliceTable() {
      console.log("splice table");
      // this.gridApi.sizeColumnsToFit();
      if (
        this.$route.path.includes("createinvoice") ||
        this.$route.path.includes("invoice") ||
        this.$route.path.includes("editinvoice")
      ) {
        this.getTable.column.splice(8, 1);
      } else if (this.$route.path.includes("createreceipt")) {
        this.getTable.column.splice(6, 1);
        return;
      } else {
        this.getTable.column.splice(6, 1);
      }
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    changeTabActive(index) {
      this.$store.dispatch("home/changeTabActive", index);
    },
    onFirstDataRendered(params) {
      this.spliceTable();
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      // this.gridApi = this.gridOptions.api;
      // this.gridColumnApi = this.gridOptions.columnApi;
    },
    isFirstColumn(params) {
      var displayedColumns = params.columnApi.getAllDisplayedColumns();
      var thisIsFirstColumn = displayedColumns[0] === params.column;
      return thisIsFirstColumn;
    },
    getSelectedRowData() {
      let selectedNodes = this.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map((node) => node.data);
      // alert(`Selected Nodes:\n${JSON.stringify(selectedData)}`);
      console.log(selectedData);
      return selectedData;
    },
    setSelectedTask() {
      if (this.selectedTask) {
        this.selectedTask.forEach((task) => {
          this.gridApi.forEachNode(function(node) {
            if (!node.isSelected()) {
              node.setSelected(
                node.data.task_code === task.task_code,
                false,
                true
              );
            }
          });
        });
      }
    },
    setSelectedInvoice() {
      if (this.selectedInvoice) {
        this.selectedInvoice.forEach((invoice) => {
          this.gridApi.forEachNode(function(node) {
            if (!node.isSelected()) {
              node.setSelected(
                node.data.invoice_code === invoice.invoice_code,
                false,
                true
              );
            }
          });
        });
      }
    },
  },
  mounted() {
    this.bermuda = themeConfig.theme.bermuda;
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.setSelectedTask();
    this.setSelectedInvoice();
    // this.$store.dispatch("home/getTabComponent");
    // this.$store.dispatch("home/getColumn");
    // this.$store.dispatch("home/getAllDataUser");
  },
  created() {
    // if (
    //   this.$route.path === "/createinvoice" ||
    //   this.$route.path === "/invoice" ||
    //   this.$route.path.includes("/editinvoice")
    // ) {
    //   this.$store.dispatch("general/getSubTable", "second");
    // } else if (this.$route.path === "/receipt") {
    //   this.$store.dispatch("general/getSubTable", "third");
    // }
  },
  beforeMount() {
    // this.hell = data.column;
    // this.yeah = data.api;
    if (this.$route.path === "/managemember") {
      this.defaultColDef = {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        // headerCheckboxSelection: this.isFirstColumn,
        // checkboxSelection: this.isFirstColumn,
      };
    } else {
      this.defaultColDef = {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      };
    }
  },
  updated() {
    console.log("updated");
    this.setSelectedTask();
    this.setSelectedInvoice();
    this.gridApi.sizeColumnsToFit();
    // this.gridApi.sizeColumnsToFit();
    // this.getTable.column.splice(7, 1);
  },
};
</script>
<style lang="scss"></style>
